import DemoBadge from '@/components/feature/DemoBadge';

type Flow = { icon: string; title: string; body: string; output: string };

const FLOWS: Flow[] = [
  {
    icon: 'ri-pushpin-2-line',
    title: 'Community bulletin processing',
    body: 'Notices submitted to the community board would be auto-tagged by topic, screened for duplicates or spam, and routed into a moderator queue.',
    output: 'Output: a clean, sorted bulletin board awaiting a moderator.',
  },
  {
    icon: 'ri-megaphone-line',
    title: 'Sponsor inquiry management',
    body: 'Each sponsorship enquiry would be summarized, matched to the right package and paired with a suggested reply for the sales team to send.',
    output: 'Output: a ready-to-send response draft per sponsor.',
  },
  {
    icon: 'ri-mail-send-line',
    title: 'Newsletter preparation',
    body: 'The week\u2019s top stories and upcoming tournaments would be assembled into a draft digest — subject line, ordering and intro copy included.',
    output: 'Output: a reviewable digest draft, never auto-sent.',
  },
];

export default function FutureWorkflows() {
  return (
    <section className="bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Also planned</p>
        <DemoBadge label="Conceptual workflow" />
      </div>
      <h2 className="font-heading font-bold text-4xl md:text-6xl text-foreground-950 leading-[1.02]">Three more workflows on the roadmap</h2>
      <p className="mt-4 text-foreground-600 max-w-2xl">
        Beyond tournaments, the same assist-then-review model is planned for the day-to-day work behind the scenes.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        {FLOWS.map((f) => (
          <article key={f.title} className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6 md:p-7">
            <span className="w-12 h-12 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-2xl"><i className={f.icon}></i></span>
            <h3 className="mt-5 font-heading font-bold text-2xl text-foreground-950 leading-tight">{f.title}</h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{f.body}</p>
            <p className="mt-5 flex items-start gap-2 text-xs text-accent-900 bg-accent-100 border border-accent-300 rounded-md px-3 py-2">
              <span className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5"><i className="ri-check-double-line"></i></span>
              {f.output}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}